import { render, staticRenderFns } from "./ProjectOfferFromRSP.vue?vue&type=template&id=687d1a49&scoped=true&"
import script from "./ProjectOfferFromRSP.vue?vue&type=script&lang=js&"
export * from "./ProjectOfferFromRSP.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOfferFromRSP.vue?vue&type=style&index=0&id=687d1a49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d1a49",
  null
  
)

export default component.exports